import * as React from "react";

const Box = (props: any) => (
  <svg
    width={64}
    height={64}
    viewBox="0 0 64 64"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path id="a" d="M0 0h46v33H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(9 16)">
        <use fill="#FFF" xlinkHref="#a" />
        <path stroke="#7B838C" strokeWidth={4} d="M2 2v29h42V2H2z" />
      </g>
      <path fill="#D2D5D8" d="M13 20h38v25H13z" />
    </g>
  </svg>
);

export default Box;

